import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import SidePanel from "share/templates/SidePanel";
import { Wrap } from "./styles";
import NtatHeader from "share/organisms/headers/ntat-header";
import { getEmployeeDetailsRequest } from "../../student/Login/actions";

const WithSidepanelLayout = ({
  children,
  styles,
  showHeader = true,
  showWelcome = false,
  showSidebar = true,
  headerOptions = {},
  contentOptions = {},
  showSupportHandsetHeader = false,
  showHeading = false,
  handleBack = () => {},
  heading = "",
  ...rest
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getEmployeeDetailsRequest());
  }, []);
  return (
    <Wrap className="d-flex" style={styles} showSidebar={showSidebar} {...rest}>
      {showSidebar && (
        <section className="left-section">
          <SidePanel />
        </section>
      )}
      <section className="right-section">
        <div className="desktop-header">
          {showHeader && (
            <NtatHeader showWelcome={showWelcome} {...headerOptions} />
          )}
        </div>

        <div className="handset-header">
          {showHeader && (
            <NtatHeader
              showWelcome={false}
              {...headerOptions}
              showSupportHandsetHeader={showSupportHandsetHeader}
              showHeading={showHeading}
              handleBack={handleBack}
              heading={heading}
            />
          )}
        </div>

        <div className="container-fluid" {...contentOptions}>
          {children}
        </div>
      </section>
    </Wrap>
  );
};

export default WithSidepanelLayout;

WithSidepanelLayout.propTypes = {
  children: PropTypes.node,
};
